import { useMutation } from '@tanstack/react-query';

import {
    UpdateSubscriptionItemsParams,
    UpdateSubscriptionItemsPayload,
    UpdatedSubscriptionItemsResponse,
} from '@/api/subscriptions/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';
import { STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY } from '@/config';

export const updateSubscriptionItems = (
    params: UpdateSubscriptionItemsParams
): Promise<UpdatedSubscriptionItemsResponse> => {
    const payload: UpdateSubscriptionItemsPayload = {
        subscription_id: params.subscriptionId,
        items: params.items,
    };
    if (params.prorationBehavior) {
        payload.proration_behavior = params.prorationBehavior;
    }
    if (params.prorationTimestamp) {
        payload.proration_timestamp = params.prorationTimestamp;
    }
    if (params.promotionCode) {
        payload.promotion_code = params.promotionCode;
    }

    return axios.put('/api/v2/subscriptions/items', payload);
};

type UseUpdateSubscriptionItemsOptions = {
    config?: MutationConfig<typeof updateSubscriptionItems>;
    data?: UpdateSubscriptionItemsParams;
};

export const useUpdateSubscriptionItems = ({ config }: UseUpdateSubscriptionItemsOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: updateSubscriptionItems,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['stripe-subscription-info'] });
            queryClient.invalidateQueries({ queryKey: ['stripe-updated-quantity-upcoming-invoice'] });
            queryClient.invalidateQueries({ queryKey: [STRIPE_CURRENT_CUSTOMER_INFO_QUERY_KEY] });
            queryClient.invalidateQueries({ queryKey: ['stripe-invoices-list'] });
        },
    });
};
